import { Input, Component, ElementRef, HostBinding, OnInit, OnDestroy, inject } from '@angular/core';
import { AccountModalComponent } from "src/app/accounts/wizards/modal/account-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AccountsService } from "src/app/accounts/accounts.service";
import { AccountsContextService } from "src/app/accounts/account-context.service";
import { Router } from "@angular/router";
import { defaultMenuOptions, MenuComponent } from "../../../../../kt/components";
import { Account } from 'src/app/shared/account/account.types';
import { map, takeUntil } from 'rxjs/operators';
import { combineLatest, Observable, Subject } from 'rxjs';
import { PublisherAclService } from 'src/app/publisher/publisher-acl.service';
import { AdvertiserAclService } from 'src/app/advertiser/advertiser-acl.service';
import { WhiteLabelService } from 'src/app/white-label/white-label.service';
import { ICreateAccount } from 'src/app/shared/account/create-account.helper';

export type AccountSwitcherTabsType =
  | 'account-switcher-tab-1'
  | 'account-switcher-tab-2';


/*
ToDo: rename it to AccountSelector
 */
@Component({
  selector: 'app-notifications-inner',
  templateUrl: './notifications-inner.component.html',
  styleUrls: ['./notifications-inner.component.scss'],
})
export class NotificationsInnerComponent implements OnInit, OnDestroy {
  @Input() triggerRef: ElementRef;
  @HostBinding('class')
  public readonly class = 'menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px';

  public accountType = Account.Type;
  public activeTabId: AccountSwitcherTabsType = 'account-switcher-tab-1';
  public searchQuery: string = '';

  public readonly whiteLabelService: WhiteLabelService;
  
  private destroyed$: Subject<void> = new Subject();

  constructor(
    public publisherAclService: PublisherAclService,
    public advertiserAclService: AdvertiserAclService,
    public accountsService: AccountsService,
    public accountsCtxService: AccountsContextService,
    private modalService: NgbModal,
    private router: Router,
    private elRef: ElementRef,
  ) {
    this.whiteLabelService = inject(WhiteLabelService);
  }

  public get showAccountTypeSwitcher$(): Observable<boolean> {
    return combineLatest([
      this.accountsService.advertisers$,
      this.accountsService.publishers$
    ])
    .pipe(
      map(([advertisers, publishers]) => !this.whiteLabelService.isWhiteLabel || !!(advertisers.length && publishers.length))
    );
  }

  public ngOnInit(): void {
    if (!MenuComponent.getInstance(this.elRef.nativeElement)) {
      new MenuComponent(this.elRef.nativeElement, defaultMenuOptions);
    }

    this.accountsCtxService.account$
      .pipe(
        takeUntil(this.destroyed$),
        map(
          acc => acc.accountType === Account.Type.PUBLISHER
            ? 'account-switcher-tab-1'
            : 'account-switcher-tab-2'
        )
      )
      .subscribe(
        activeTab => this.activeTabId = activeTab
      );
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public openModal(accountType: Account.Type) {
    const modalRef = this.modalService.open(AccountModalComponent, {
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.accountType = accountType;
    modalRef.componentInstance.modalReference = modalRef;
  }

  public setActiveTabId(tabId: AccountSwitcherTabsType) {
    this.activeTabId = tabId;
  }

  public changeAccount(id: string, accountType: any) {
    this.searchQuery = '';
    if (accountType === 'shop') {
      this.router.navigate(['publisher/' + id + '/dashboard']);
    } else {
      this.router.navigate(['advertiser/' + id + '/campaigns']);
    }

    // Close Menu
    this.triggerRef.nativeElement.click();
  }
}
